/**
 * Sélecteur de société (autocomplete)
 * Basé sur le composant générique AutocompleteSelect
 */

import { AutocompleteSelect } from '@/Components/shared/AutocompleteSelect';
import type { SocietyListItem } from '@/features/societies/types/society.types';

interface SocietySelectorProps {
  value: string | undefined;
  onChange: (societyId: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  filterActive?: boolean;
  size?: 'default' | 'sm';
  tooltip?: string;
}

export const SocietySelector = ({
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  filterActive = true,
  size = 'default',
  tooltip,
}: SocietySelectorProps) => {
  return (
    <div>
      <AutocompleteSelect<SocietyListItem>
        apiEndpoint="/societies"
        searchParam="nameFilter"
        getOptionLabel={(s) => s.name}
        getOptionValue={(s) => s.uuid}
        value={value || null}
        onChange={(uuid) => onChange(uuid || '')}
        label="Société"
        required={required}
        placeholder="Sélectionner une société..."
        disabled={disabled}
        size={size}
        tooltip={tooltip}
        filterActive={filterActive}
        additionalParams={filterActive ? { isActiveFilter: true } : {}}
        renderOption={(society) => (
          <div>
            <div className="tw-font-medium">{society.name}</div>
            {society.rootParentName && (
              <div className="tw-text-xs tw-text-gray-500">
                Groupe : {society.rootParentName}
              </div>
            )}
          </div>
        )}
      />
      {error && <p className="tw-mt-1 tw-text-sm tw-text-red-600">{error}</p>}
    </div>
  );
};
